export const CHANNELS = 'channels'
export const ERROR_EMPTY = 'I should not be empty!'
export const ERROR_URL_NOT_VALID = 'I should be a valid URL!'
export const ERROR_INVALID_JSON = 'I should be valid JSON'